export const SIDEBAR_OPEN_KEY = 'sideBarOpen';
